import { render, staticRenderFns } from "./Nofound.vue?vue&type=template&id=0799e7fc&"
import script from "./Nofound.vue?vue&type=script&lang=js&"
export * from "./Nofound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports